import * as z from 'zod';

// Must match Contentful space role names exactly.
export const UserRoleEnum = z.enum([
  'Editor',
  'Author',
  'Tester',
  'Campaign Manager',
]);
export type UserRoleEnum = z.infer<typeof UserRoleEnum>;
